import * as tslib_1 from "tslib";
// See: https://github.com/jorgebucaran/hyperapp-router/blob/19f95f843ae2dc5b4d83f9647edc591a6450c4e3/src/Link.js
import { m } from '../hyperscript';
import { View } from '../ui/view';
import { addClasses } from '../util/classes';
import { Location } from './router';
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _a = this.attrs, to = _a.to, target = _a.target, download = _a.download, onclick = _a.onclick, children = _a.children, attrs = tslib_1.__rest(_a, ["to", "target", "download", "onclick", "children"]);
        return m(Location, function (location) {
            var href = location.formatPath(to);
            var active = !!location.match({ path: to, exact: attrs.exact });
            var anchorAttrs = addClasses(tslib_1.__assign({}, attrs, { href: href,
                target: target,
                download: download, onclick: function (e) {
                    e.redraw = false;
                    if (onclick)
                        onclick(e);
                    var ignore = download ||
                        target === '_blank' ||
                        ignoreClick(e) ||
                        isExternal(location, e.currentTarget);
                    if (ignore)
                        return;
                    e.preventDefault();
                    location.push(href);
                } }), { is: { active: active } });
            return m('a', anchorAttrs, children);
        });
    };
    return Link;
}(View));
export { Link };
var ignoreClick = function (e) {
    return e.defaultPrevented ||
        e.button !== 0 ||
        e.altKey ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey;
};
var isExternal = function (location, anchorElement) { return getOrigin(location) !== getOrigin(anchorElement); };
var getOrigin = function (_a) {
    var protocol = _a.protocol, hostname = _a.hostname, _b = _a.port, port = _b === void 0 ? '' : _b;
    return protocol + "//" + hostname + (port && ":" + port);
};
